import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Constraint from '../../01-atoms/Constraint/Constraint';
import PostBody from '../../02-molecules/PostBody/PostBody';
import Text from '../../01-atoms/Text/Text';
import slugify from '../../../utilities/slugify';

import './BlogPost.css';

const BlogPost = ({
  authors,
  body,
  category,
  description,
  image,
  date_published,
  embeddedImagesLocal,
  embeddedImagesRemote,
  tableOfContents,
  tags,
  title,
}) => (
  <article className="BlogPost">
    <header className="BlogPost__header">
      <Constraint>
        <div className="BlogPost__header-wrapper">
          <div className="BlogPost__header-content">
            <Text semanticLevel={1}>{title}</Text>
            <Text>{description}</Text>
            {/*(!!date_published || (!!authors && !!authors.length)) && (
              <Text>
                {!!date_published && <time>{date_published}</time>}
                {!!authors && !!authors.length && (
                  <span>
                    {` `}
                    by{` `}
                    {authors
                      .map((author) => author.frontmatter.full_name)
                      .join(`, `)}
                  </span>
                )}
              </Text>
            )*/}
          </div>

          <div className="BlogPost__header-cover">
            <GatsbyImage
              alt={image.alt}
              image={image.src.childImageSharp.gatsbyImageData}
              loading="eager"
            />
          </div>
        </div>
      </Constraint>
    </header>

    <PostBody
      className="BlogPost__body"
      embeddedImagesLocal={embeddedImagesLocal}
      embeddedImagesRemote={embeddedImagesRemote}
      tableOfContents={tableOfContents}
    >
      {body}
    </PostBody>

    <footer className="BlogPost__footer">
      {!!category && (
        <p>
          Category:{` `}
          <Link to={`/blog/category/${slugify(category)}`}>{category}</Link>
        </p>
      )}
      {!!tags && !!tags.length && (
        <div className="BlogPost__tags-section">
          <span>Tags:</span>
          <ul className="BlogPost__tags">
            {tags.map((tag) => {
              const slug = slugify(tag);
              return (
                <li key={slug}>
                  <Link to={`/blog/tag/${slug}`}>{tag}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </footer>
  </article>
);

export default BlogPost;
